<template>
  <div class="w-full">
      <div class="temp-page px-4 h-screen w-full">
        <div class="container xl:max-w-screen-lg mx-auto h-full flex items-center justify-start">
        <div class="max-w-sm md:max-w-xl">
          <small class=" color-light font-medium text-sm">
            CLAONS DESIGNS
          </small>
          <h1 class="text-white text-capitalize mb-4 font-semibold text-4xl md:text-5xl">
            We Design Modern Elegant Interior & Exterior
          </h1>
          <p class="text-white font-light text-lg">
            At Claons designs, we see Architecture as an art form that reflects how we present ourselves.
          </p>
        </div>
        </div>
      </div>
  </div>
</template>

<style scoped>

.temp-page {
  background: rgba(0, 0, 0, .5)  url('../assets/commercial/hotel/t.jpg') no-repeat center center / cover ;
  background-blend-mode: overlay;
  /* height: 100vh; */
  /* width: 100vw; */
  color: white;
}

</style>
